import { getters } from "./model";
import { createSelector } from "reselect";
import * as R from "ramda";
import * as FormSelectors from "ui-kit/Form/selectors";
import { eventDetails as getEventDetails } from "redux/modules/event/selectors";

export const getEditingField = R.compose(
  field => ({
    type: R.path(["meta", "fieldType"], field),
    value: field.value
  }),
  FormSelectors.getField
);

export const getValues = createSelector(getters.customFields, customFields =>
  R.compose(
    R.map(v => ({
      type: v.type,
      value: v && v.value && v.value.value ? v.value.value : null
    })),
    R.indexBy(R.prop("field_id"))
  )(R.propOr([], "values", customFields))
);

export const getFields = createSelector(
  getters.customFields,
  getters.translatedValues,
  getValues,
  getEventDetails,
  (customFields, translatedValues, fieldValues, eventDetails) => {
    if (R.isNil(customFields) || R.isEmpty(customFields)) {
      return [];
    }

    let {
      fields = [],
      default_preferences: { visible_fields = [], field_order = [] }
    } = customFields || {};

    fields = fields.map(f => {
      let translatedValuesForField = translatedValues.filter(
        v => v.field_id === f.id
      );
      const hasTranslations = Boolean(translatedValuesForField.length);
      if (hasTranslations) {
        translatedValuesForField = [
          {
            ...translatedValuesForField[0],
            translated_field_name: translatedValuesForField[0].field_name,
            translated_value: fieldValues[f.id] ? fieldValues[f.id] : null,
            language: eventDetails.language,
            language_label: "English",
            is_default: true
          },
          ...translatedValuesForField.map(v => ({
            ...v,
            is_default: false
          }))
        ];
      }

      f.translations = translatedValuesForField;

      f.has_translations = hasTranslations;

      return f;
    });

    return R.compose(
      R.sortBy(f => field_order[R.prop("id", f)]),
      R.filter(x => R.contains(R.prop("id", x), visible_fields))
    )(fields);
  }
);

export const getTranslatedValuesForField = createSelector(
  getters.selectedTranslatedFieldId,
  getters.translatedValues,
  getValues,
  getEventDetails,
  (selectedTranslatedFieldId, translatedValues, fieldValues, eventDetails) => {
    const values = translatedValues.filter(
      v => v.field_id === selectedTranslatedFieldId
    );
    if (values.length) {
      return [
        {
          ...values[0],
          translated_field_name: values[0].field_name,
          translated_value:
            fieldValues[selectedTranslatedFieldId] &&
            fieldValues[selectedTranslatedFieldId].value
              ? fieldValues[selectedTranslatedFieldId].value
              : null,
          language: eventDetails.language,
          language_label: "English",
          is_default: true
        },
        ...values.map(v => ({
          ...v,
          translated_value:
            v.translated_value && v.translated_value.value
              ? v.translated_value.value
              : null,
          is_default: false
        }))
      ];
    }
    return [];
  }
);

export const getField = createSelector(
  getFields,
  (_, props) => props.fieldId,
  (fields, fieldId) => R.find(R.propEq("id", fieldId))(fields)
);

export const getFieldValue = createSelector(
  getValues,
  (_, props) => props.fieldId,
  (values, fieldId) => R.prop(fieldId, values)
);
